export default __webpack_public_path__ + "static/media/banner_nos-renovamos_mobile-lg.8e2d4c63.jpg";